import React from "react";
import { Dropdown } from "react-bootstrap";
import Dropzone from "react-dropzone";

import "assets/scss/transfer.scss";

interface FileUploaderProps {
  selectedFiles: any[];
  setSelectedFiles: React.Dispatch<React.SetStateAction<any[]>>;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  selectedFiles,
  setSelectedFiles,
  ...props
}) => {
  const handleAcceptedFiles = (files: any[]) => {
    var allFiles = files;

    allFiles = [...selectedFiles];
    allFiles.push(...files);
    setSelectedFiles(allFiles);
  };

  return (
    <Dropzone
      {...props}
      onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
    >
      {({ getRootProps, getInputProps }) => (
        <div className="dropzone">
          <div className="dz-message needsclick" {...getRootProps()}>
            <input {...getInputProps()} />
            <i className="h3 text-muted dripicons-cloud-upload"></i>
            <h4>Solte arquivos aqui ou clique para fazer o upload.</h4>
          </div>
        </div>
      )}
    </Dropzone>
  );
};

const UploadFilesDropdown: React.FC<FileUploaderProps> = ({
  selectedFiles,
  setSelectedFiles,
}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant="light" id="click-dropdown">
        <i className="mdi mdi-file-multiple-outline"></i>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <div id="dropdown-fileuploader">
          <FileUploader
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default UploadFilesDropdown;
